(function () {
  var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var raf = null; // module-level so cancelAnimationFrame always hits the live handle

  function scramble(el, original) {
    cancelAnimationFrame(raf); // kill any in-progress loop before starting a new one
    var frame = 0;
    var totalFrames = 20;
    var length = original.length;

    function tick() {
      var resolved = Math.floor((frame / totalFrames) * length);
      el.textContent = original.split('').map(function (char, i) {
        if (char === ' ') return ' ';
        if (i < resolved) return original[i];
        return CHARS[Math.floor(Math.random() * CHARS.length)];
      }).join('');
      frame++;
      if (frame <= totalFrames) {
        raf = requestAnimationFrame(tick);
      } else {
        el.textContent = original; // guarantee clean final state
        raf = null;
      }
    }

    tick();
  }

  function init() {
    var link = document.querySelector('.header__heading-link');
    if (!link) return;
    var textEl = link.querySelector('.h2') || link.querySelector('span') || link;
    var original = textEl.textContent.trim(); // captured once at init, never from scrambled state

    // Lock the link container to its natural width — don't touch the inner span's display
    link.style.width = link.getBoundingClientRect().width + 'px';
    link.style.overflow = 'hidden';
    link.style.flexShrink = '0';
    textEl.style.whiteSpace = 'nowrap';

    link.addEventListener('mouseenter', function () {
      scramble(textEl, original);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
